export function openDatabase() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open("centralfoz", 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains('diagnostics')) {
                db.createObjectStore('diagnostics', { keyPath: "id_project", autoIncrement: true });
            }
        };

        request.onsuccess = (event) => {
            resolve(event.target.result);
        };

        request.onerror = (event) => {
            console.error("Error opening database:", event.target.error);
            reject(event.target.error);
        };
    });
}

export function openInstallationsDatabase() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open("centralfoz_installations", 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains('installations')) {
                db.createObjectStore('installations', { keyPath: "id_project", autoIncrement: true });
            }
        };

        request.onsuccess = (event) => {
            resolve(event.target.result);
        };

        request.onerror = (event) => {
            console.error("Error opening installations database:", event.target.error);
            reject(event.target.error);
        };
    });
}

export function deleteInstallationData(idProject) {
    return new Promise((resolve, reject) => {
        openInstallationsDatabase().then(db => {
            const transaction = db.transaction(['installations'], 'readwrite');
            const store = transaction.objectStore('installations');
            const request = store.delete(idProject);

            request.onsuccess = () => {
                resolve();
            };

            request.onerror = (event) => {
                console.error("Error deleting installation data:", event.target.error);
                reject(event.target.error);
            };
        }).catch(error => {
            reject(error);
        });
    });
}
